import React, { Component, Fragment } from 'react';
import MoreViewsCarouselButtons from './MoreViewsCarouselButtons';
import { normalize as normalizeCGI } from '../../../client/api/config/normalizeCGI';
import { connect } from 'react-redux';
import { computeDefaultAngle } from '../../common/cgi/cgiHelpers';
import { PhotoSwipe } from 'react-pswp';

const INTERIOR_ANALYTICS_KEY = 'gallery:interior';
const EXTERIOR_ANALYTICS_KEY = 'gallery:exterior';

const calculateImageArray = (images, angle) => {
  const indexOfDefault = images
    .map((img) => {
      return img.id;
    })
    .indexOf(angle);

  const imageArr = [
    ...images.slice(indexOfDefault, images.length),
    ...images.slice(0, indexOfDefault),
  ];

  return imageArr;
};

const getImageDimensions = ({ cgiZoomDimensions }) => [
  parseInt(cgiZoomDimensions.width),
  parseInt(cgiZoomDimensions.height),
];

const getWindowDimensions = (window) => [
  window.innerWidth,
  window.innerHeight - 80,
];

class MoreViewsCarousel extends Component {
  constructor(props) {
    super(props);

    this.state = { interiorIndex: 0, exteriorIndex: 0 };

    const images = this.getImages();
    const index = this.getIndex();
    this.image = images[index];
    this.loadedImages = new Map();

    this.ref = React.createRef();
    this.onPrev = this.onPrev.bind(this);
    this.onNext = this.onNext.bind(this);
  }

  onPrev() {
    const images = this.getImages();

    if (images.length > 0) {
      const index = this.getIndex();
      const prevIndex = index - 1 >= 0 ? index - 1 : images.length - 1;
      this.onChangeIndex(prevIndex);
    }
  }

  onNext() {
    const images = this.getImages();

    if (images.length > 0) {
      const index = this.getIndex();
      const nextIndex = index + 1 < images.length ? index + 1 : 0;
      this.onChangeIndex(nextIndex);
    }
  }

  onChangeIndex(index) {
    !this.props.isExteriorView
      ? this.setState({ interiorIndex: index })
      : this.setState({ exteriorIndex: index });
  }

  getImages() {
    const { images, isExteriorView, imageAngle, appResources } = this.props;
    const { exteriorAngles, interiorAngles, wheelAngles } = appResources;
    const { exterior: exteriorImages, interior: interiorImages } = images;

    const angle = computeDefaultAngle(
      imageAngle,
      exteriorAngles,
      interiorAngles,
      wheelAngles,
      !isExteriorView
    );

    return calculateImageArray(
      !isExteriorView ? interiorImages : exteriorImages,
      angle
    );
  }

  getIndex() {
    const { isExteriorView } = this.props;
    return !isExteriorView
      ? this.state.interiorIndex
      : this.state.exteriorIndex;
  }

  render() {
    const { isExteriorView, isConvertibleTopDown } = this.props;

    const analyticsKey = !isExteriorView
      ? INTERIOR_ANALYTICS_KEY
      : EXTERIOR_ANALYTICS_KEY;

    const images = this.getImages();
    const index = this.getIndex();

    const carouselContainer = images.map((image, i) => ({
      uid: i,
      src: image.zoomUrl,
      msrc: image.zoomUrl,
      w: image.cgiZoomDimensions.width,
      h: image.cgiZoomDimensions.height,
    }));

    const carouselOptions = {
      loop: true,
      closeElClasses: [],
      closeOnVerticalDrag: false,
      closeOnScroll: false,
      pinchToClose: false,
      clickToCloseNonZoomable: false,
      escKey: false,
      showAnimationDuration: 0,
      hideAnimationDuration: 0,
      errorMsg: `<div class="pswp__error-msg">${this.props.fallbackText}</div>`,
      mainClass: `pswp--${isExteriorView ? 'exterior' : 'interior'}`,
      barsSize: { top: 0, bottom: 0 },
    };

    const carouselKey =
      (isExteriorView ? 1 : 2) + (isConvertibleTopDown ? 1 : 2);

    return (
      <Fragment>
        <div className="carousel carousel--single" ref={this.ref}>
          <MoreViewsCarouselButtons
            isVisible={images.length > 1}
            analyticsKey={analyticsKey}
            onPrev={this.onPrev}
            onNext={this.onNext}
          />
          <PhotoSwipe
            key={carouselKey}
            container={carouselContainer}
            onIndexChange={(newIndex) => {
              this.onChangeIndex(newIndex);
            }}
            index={index}
            open={true}
            options={carouselOptions}
          />
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  const { appResources, breakpoint, config, cgi } = state;
  const images = normalizeCGI(
    appResources,
    config,
    cgi.isConvertibleTopDown,
    breakpoint
  );

  return {
    images,
    appResources,
  };
};
export { calculateImageArray, getImageDimensions, getWindowDimensions };
export default connect(mapStateToProps)(MoreViewsCarousel);
